import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MasterItemsService {
  public mtds: Methods = new Methods();
  public url: string;
  public urlUser: string;
  public token;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/masteritem/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
  }

  create(json): Observable<any> {
    if (json.non_inventory) {
      json.non_inventory = 1;
    }
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'new', json);
  }

  changestatus(json: any): Observable<any> {

     let params = `authorization=${this.token}`;

           if (json) {
                params += `&json=${JSON.stringify(json)}`;
              }          
    
        const headers = new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        });
   
    this.url = GLOBAL.url + '/masteritem/';
    
        return this._http
          .post(`${this.url}changestatus`, params, {
            headers: headers,
          })
          .pipe(map((res) => res));
  }

  update(json, id): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'edit/' + id, json);
  }

  search(item): Observable<any> {
    return this.petition(`${GLOBAL.url}/masteritem/search`, { busqueda: item });
  }

  syncOne(item): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get('https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-one-item.php?id=' + item, { headers: headers });
  }

  showOne(id): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'detail/' + id);
  }

  markscrap(id, notes): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'modifyscrapstatus/' + id, { status: 1, scrap_notes: notes });
  }

  moveInventoryToScrap(inventory_id): Observable<any> {
    const json = { value: 1, field: "nonInventory" };
    return this.petition(GLOBAL.url + '/inventory/especificedit/' + inventory_id, json);
  }

  unscrap(id): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'modifyscrapstatus/' + id, { status: 0 });
  }

  bulkcrap(id, json): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'bulkmodifyscrapstatus/' + id, json);
  }

  getCategoryByAI(item, mfgr): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.get('https://www.itaderp.com/backend/reports/choose-category-mi.php?item='+item+'&mfgr='+mfgr, { headers: headers });
  }


  weightrequired(requ): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(GLOBAL.url + '/company/wetweightrequired', { weightRequired: Number(requ) });
  }
  
  getAllDat(page, perPage, filtros = [],data): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/getAllPaginated?';
    let json = data;
    

    this.url = this.url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        this.url = this.url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          this.url = this.url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(this.url, json);
  }

  showAll(page, perPage, busqueda = '', status = '', mfgr = '', activo = 1, filtros = []): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/list?';
    let json = null;
    if (busqueda === "" && status === '' && mfgr === '') {
      json = {
        activo
      };
    } else if (busqueda !== "" && status === '' && mfgr === '') {
      json = {
        busqueda: busqueda,
        activo
      };
    } else if (busqueda !== "" && status !== '' && mfgr === '') {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        activo
      };
    } else if (busqueda !== "" && status === '' && mfgr !== '') {
      json = {
        busqueda: busqueda,
        filtertype: "mfgr",
        filtervalue: mfgr,
        activo
      };
    } else if (busqueda !== "" && status !== '' && mfgr !== '') {
      json = {
        busqueda: busqueda,
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        activo
      };
    } else if (busqueda === "" && status !== '' && mfgr !== '') {
      json = {
        filtertype: "status",
        filtervalue: status,
        filtersecondtype: "mfgr",
        filtersecondvalue: mfgr,
        activo
      };
    } else if (busqueda === "" && status !== '' && mfgr === '') {
      json = {
        filtertype: "status",
        filtervalue: status,
        activo
      };
    } else if (busqueda === "" && status === '' && mfgr !== '') {
      json = {
        filtertype: "mfgr",
        filtervalue: mfgr,
        activo
      };
    }

    this.url = this.url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        this.url = this.url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          this.url = this.url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(this.url, json);
  }

  showAlls(page, perPage, busqueda = '', status = '', mfgr = '', activo = 1, filtros = [],task:any,
  order:any): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/list?';
    let json: any = {
      sort: [task],
      order: order,
      activo: activo
    };
  
    if (busqueda !== "") {
      json.busqueda = busqueda;
    }
  

    if (busqueda === "" && status === "" && mfgr === "") {
      // Caso base: no se envía ningún filtro adicional.
    } else if (busqueda !== "" && status === "" && mfgr === "") {
      // Solo se envía la búsqueda (ya se agregó en el JSON)
    } else if (busqueda !== "" && status !== "" && mfgr === "") {
      json.filtertype = "status";
      json.filtervalue = status;
    } else if (busqueda !== "" && status === "" && mfgr !== "") {
      json.filtertype = "mfgr";
      json.filtervalue = mfgr;
    } else if (busqueda !== "" && status !== "" && mfgr !== "") {
      json.filtertype = "status";
      json.filtervalue = status;
      json.filtersecondtype = "mfgr";
      json.filtersecondvalue = mfgr;
    } else if (busqueda === "" && status !== "" && mfgr !== "") {
      json.filtertype = "status";
      json.filtervalue = status;
      json.filtersecondtype = "mfgr";
      json.filtersecondvalue = mfgr;
    } else if (busqueda === "" && status !== "" && mfgr === "") {
      json.filtertype = "status";
      json.filtervalue = status;
    } else if (busqueda === "" && status === "" && mfgr !== "") {
      json.filtertype = "mfgr";
      json.filtervalue = mfgr;
    }

    this.url = this.url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        this.url = this.url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          this.url = this.url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(this.url, json);
  }

  inventories(master_id): Observable<any> {
    return this.petition(`${GLOBAL.url}/inventory/listbymasterid/${master_id}`);
  }

  delete(id): Observable<any> {
    this.url = GLOBAL.url + '/masteritem/';
    return this.petition(this.url + 'remove/' + id);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams().set('authorization', this.token);

    if (json != null) {
      json = JSON.stringify(json);
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(url, params.toString(), { headers: headers })
                    .pipe(map(res => res));
  }
}
